import { useContext } from 'react'
import { Fragment } from 'react'
import NotificationContext from '../providers/NotificationContext'
import CloseIcon from '@mui/icons-material/Close'
import IconButton from '@mui/material/IconButton'
import { Snackbar } from '@mui/material'

const Notification = () => {
  const notificationCtx = useContext(NotificationContext)

  const handleClose = () => {
    notificationCtx.handlers.clear()
  }

  const action = (
    <Fragment>
      <IconButton size="small" aria-label="close" color="inherit" onClick={handleClose}>
        <CloseIcon fontSize="small" />
      </IconButton>
    </Fragment>
  )

  return (
    <>
      {notificationCtx.data.state && (
        <Snackbar
          open={notificationCtx.data.state !== null}
          autoHideDuration={5000}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
          onClose={handleClose}
          message={notificationCtx.data.text}
          action={action}
        />
      )}
    </>
  )
}

export default Notification
